import { RevenueItem } from './revenue-item.model';

export enum WC_OptionalRevenueItemAction {
  NoAction = 0,
  Add = 1,
  Rebalance = 2,
}

export interface OptionalRevenueItemDto {
  ID: number;
  ItemNum: number;
  Descr: string;
  FlatAmount: number;
  PercentOfLineItemAmount: number;
  DateCreated: Date;
  DateChanged: Date;
  ChangedBy: string;
  ItemNum_Optional: number;
  OptIn: boolean;
  OptOut: boolean;
  Action: WC_OptionalRevenueItemAction;
  PaymentTypeId: number;
  ForceModification: boolean;
  IsOptional: boolean;
  IsHidden: boolean;
  IsCustomAmount: boolean;
  Inactive: boolean;
  RebalanceAdjustmentTypeId: number;
  ActionDisplay: string;
  ParentRevenueItemDisplay: string;
  ChildRevenueItemDisplay: string;
  ComputedAmount: number;
  UseLineItemApplyDate: boolean;

  RevenueItem: RevenueItem;
  RevenueItem1: RevenueItem;
}

export function initializedOptionalRevenueItemDto(partialDto?: Partial<OptionalRevenueItemDto>) {
  const defaultDto = {
    Action: WC_OptionalRevenueItemAction.NoAction,
    FlatAmount: 0,
    PercentOfLineItemAmount: 0,
    Inactive: false,
    IsOptional: true,
  } as OptionalRevenueItemDto;

  return { ...defaultDto, ...(partialDto ?? {}) } as OptionalRevenueItemDto;
}
